module.exports = __webpack_public_path__ + "img/card-6.923bfea3.png";